export const IMG_PATH = 'http://api2.guoguohaoa.com/static/images'